import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, CanActivate, Router } from "@angular/router";
import {
  MotorDataDataService,
  MsdRequestData
} from "src/app/share/data-service/motor.data.service";
import { FieldData } from "src/app/share/interface/common.interface";
import { AlertService } from "src/app/share/service/alert.service";
import { PartnerService } from "src/app/share/service/partner.service";
import { PartnerDataService } from "src/app/share/service/partnerData.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ApproveApplicationComponent } from "../../../components/approve-application/approve-application.component";
import { RejectApplicationComponent } from "../../../components/reject-application/reject-application.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IAvailableBanners } from "src/app/share/interface/motor.interface";
import { catchError, tap, throwError } from "rxjs";
import { AuthService } from "src/app/share/service/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  id: string;
  partnerCode: string;

  data: MsdRequestData;

  sectionList: SectionList[] = [];
  summaryList: FieldData[] = [];
  documentList: any[] = [];
  printDocument: any;

  terms: number[] = Array.from({ length: 6 }, (_, i) => i + 1);

  datePipe = new DatePipe("en-GB");

  activeTabIndex = 0;

	formGroup: FormGroup;
	hide: boolean = true;
	availableBanners: IAvailableBanners[] = [];
	loadedBanners: number = 0;
	bannerLink: string = "https://storage.googleapis.com/ps-asset/affiliate/landing/kopetro-banner_1-en.png";
  approverId: string = "";


  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private ngxSpinnerService: NgxSpinnerService,
    private alertService: AlertService,
    private partnerService: PartnerService,
    private partnerDataService: PartnerDataService,
    private motorDataDataService: MotorDataDataService,
		private formBuilder: FormBuilder,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,

  ) {
    this.id = this.activatedRoute.snapshot.params.id;
    if (this.authService.isLoggedIn()) {
      this.approverId = this.authService.getUserId();
    }
  }

  ngOnInit(): void {
		this.initForm();
		this.getAvailableBanners();


    this.initPartnerDetail();
    // this.getMsdDetail();
    // this.getMsdDocument();
  }

  

	private initForm(): void {
			this.formGroup = this.formBuilder.group({
				email: [null, Validators.required, Validators.email], 
			  password: [null, Validators.required]
			});
	}

	 private getAvailableBanners(): void {
			this.motorDataDataService.getAvailableBanners().subscribe({
				next: (x: IAvailableBanners[]) => {
					this.availableBanners = x.filter(
						(banner) =>
							banner.status === "Active" &&
							(banner.refType?.includes("desktop_square") ||
								banner.refType?.includes("mobile_square"))
					);
				},
				error: () => {
					console.log("Failed to retrieve available campaigns.");
				}
			});
		}

		  countLoadedBanners(): void {
    this.loadedBanners++;

    // if (this.loadedBanners > 1) {
    //   this.swiper.swiperRef.setGrabCursor();
    // }
  }

	goToForgotPass() {
		this.router.navigate(['/forgot-password'], {
      queryParams: { 
      returnUrl: this.activatedRoute.snapshot.queryParams.returnUrl,
      partnerCode: 'prolindung'
    }
  });
	}

	login() {
		if (this.formGroup.invalid) return;
		let value = this.formGroup.value;
		// this.loadingService.loadingOn(true);

		this.motorDataDataService.loginReviewApplication(value.email, value.password)
			.pipe(
				catchError((err) => {
					this.alertService.openSnackBar("Maklumat Pengguna Tidak Sah");
					return throwError(err);
				}),	
				tap((x) => {
          let decodedToken = this.authService.decodeToken(x);
					if(decodedToken.IsActive == 'False'){
						this.alertService.openSnackBar(this.translate.instant('error.userDeactivated'));
						return;
					}
          this.authService.setToken(x);
					// if (this.partnerCode.length) localStorage.setItem("partner", this.partnerCode);
          if (this.authService.isLoggedIn()) {
            this.approverId = this.authService.getUserId();
          }
					this.redirectToPage();
				}),
				// finalize(() => this.loadingService.loadingOff(true))
			).subscribe();
	}

  private redirectToPage() {
		location.href = `${this.activatedRoute.snapshot.queryParams.returnUrl + "?partnerCode=" + this.activatedRoute.snapshot.queryParams.partnerCode}`;
	}

  async initPartnerDetail(): Promise<void> {
    this.partnerCode = await this.partnerService.getPartnerCode();
    this.partnerDataService.getPartnerDetail(this.partnerCode);
  }

  // getMsdDetail(): void {
  //   this.ngxSpinnerService.show();
  //   this.motorDataDataService.getMsdRequestDetailByPolicyId(this.id).subscribe({
  //     next: (value: MsdRequestData) => {
  //       this.data = value;

  //       this.initSection(value);
  //       this.ngxSpinnerService.hide();
  //     },
  //     error: () => {
  //       this.alertService.openSnackBar("Please contact PolicyStreet");
  //       this.ngxSpinnerService.hide();
  //     }
  //   });
  // }

  // getMsdDocument(): void {
  //   this.ngxSpinnerService.show();
  //   this.motorDataDataService.getMsdDocument(this.id).subscribe({
  //     next: (value: any[]) => {
  //       this.documentList = value.filter(
  //         (obj) => obj.documentType === "Payslip"
  //       );

  //       this.printDocument = value.find(
  //         (obj) => obj.documentType === "Application Form"
  //       );

  //       this.ngxSpinnerService.hide();
  //     },
  //     error: () => {
  //       this.alertService.openSnackBar("Please contact PolicyStreet");
  //       this.ngxSpinnerService.hide();
  //     }
  //   });
  // }

  private initSection(msd: MsdRequestData): void {
    this.sectionList = [
      {
        section: "prolindung.reviewApplication.applicantInfo",
        sectionList: [
          {
            sectionTitle: "prolindung.reviewApplication.applicantInfo",
            sectionIcon: "person",
            fieldList: [
              { codeDesc: "common.name", codeValue: msd.name },
              { codeDesc: "common.newIC", codeValue: msd.identityNo },
              { codeDesc: "common.emailAddress", codeValue: msd.email },
              { codeDesc: "common.staffNo", codeValue: msd.employeeId },
              { codeDesc: "common.telNo", codeValue: msd.mobileNo },
              { codeDesc: "common.memberNo", codeValue: msd.memberId },
              {
                codeDesc: "common.officeTelNo",
                codeValue: msd.officePhoneNo ?? "-"
              },
              {
                codeDesc: "common.officeTelExt",
                codeValue: msd.officePhoneExt ?? "-"
              }
            ]
          },
          {
            sectionTitle: "common.officeAddressTitle",
            sectionIcon: "location_on",
            fieldList: [
              { codeDesc: "common.addressLineOne", codeValue: msd.address1 },
              { codeDesc: "common.addressLineTwo", codeValue: msd.address2 },
              { codeDesc: "common.city", codeValue: msd.city },
              { codeDesc: "common.postcode", codeValue: msd.postcode },
              { codeDesc: "common.state", codeValue: msd.state }
            ]
          },
          {
            sectionTitle: "common.homeAddressTitle",
            sectionIcon: "location_on",
            fieldList: [
              {
                codeDesc: "common.addressLineOne",
                codeValue: msd.officeAddress1
              },
              {
                codeDesc: "common.addressLineTwo",
                codeValue: msd.officeAddress1
              },
              { codeDesc: "common.city", codeValue: msd.officeCity },
              { codeDesc: "common.postcode", codeValue: msd.postcode },
              { codeDesc: "common.state", codeValue: msd.state }
            ]
          }
        ]
      },
      {
        section: "prolindung.reviewApplication.vehicleInfo",
        sectionList: [
          {
            sectionTitle: "prolindung.reviewApplication.vehicleInsuranceInfo",
            sectionIcon: "directions_car",
            fieldList: [
              { codeDesc: "common.plateNo", codeValue: msd.vehicleNo },
              {
                codeDesc: "common.roadtaxExpiryDate",
                codeValue: this.datePipe.transform(
                  msd.roadtaxExpiryDate,
                  "dd/MM/yyyy"
                )
              },
              {
                codeDesc: "common.totalAmount",
                codeValue: `RM ${msd.totalAmount.toFixed(2)}`
              },
              {
                codeDesc: "common.stampDutyprolindung",
                codeValue: `RM ${msd.stampDuty.toFixed(2)}`
              },
              {
                codeDesc: "common.insuranceRoadtaxRenewalApplicationAmt",
                codeValue: `RM ${msd.roadtaxRenewalPayment.toFixed(2)}`
              }
            ]
          }
        ]
      },
      {
        section: "prolindung.reviewApplication.termSignature"
      }
    ];

    this.summaryList = [
      { codeDesc: "common.name", codeValue: msd.name },
      { codeDesc: "common.newIC", codeValue: msd.identityNo },
      { codeDesc: "common.staffNo", codeValue: msd.employeeId },
      { codeDesc: "common.telNo", codeValue: msd.mobileNo },
      { codeDesc: "common.plateNo", codeValue: msd.vehicleNo },
      {
        codeDesc: "common.insuranceRoadtaxRenewalApplicationAmt",
        codeValue: `RM ${msd.roadtaxRenewalPayment.toFixed(2)}`
      }
    ];
  }

  onPrint(): void {
    const binaryData: BlobPart[] = [];
    const downloadLink = document.createElement("a");

    this.motorDataDataService
      .downloadFileById(this.printDocument.id)
      .subscribe({
        next: (value) => {
          binaryData.push(value);
          downloadLink.href = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: value.type || "application/octet-stream"
            })
          );

          downloadLink.setAttribute("download", this.printDocument.fileName);
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.remove();

          setTimeout(() => URL.revokeObjectURL(downloadLink.href), 0);
        }
      });
  }

  onDownload(file: any): void {
    const binaryData: BlobPart[] = [];
    const downloadLink = document.createElement("a");

    this.motorDataDataService.downloadFileById(file.id).subscribe({
      next: (value) => {
        binaryData.push(value);
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, {
            type: value.type || "application/octet-stream"
          })
        );

        downloadLink.setAttribute("download", file.fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();

        setTimeout(() => URL.revokeObjectURL(downloadLink.href), 0);
      }
    });
  }

  onApprove(): void {
    let dialogRef = this.dialog.open(ApproveApplicationComponent, {
      autoFocus: false,
      data: {
        roadtaxRenewalPayment: this.data.roadtaxRenewalPayment,
        monthlyInstallment: this.data.monthlyInstallment,
        tenure: this.data.installmentMonths
      }
    });

    dialogRef.afterClosed().subscribe((value) => {
      if (!value) return;

      try {
        this.ngxSpinnerService.show();

        this.motorDataDataService
          .submitApplication({ id: this.id, actionType: "approve", approverId: this.approverId })
          .subscribe({
            next: () => {
              this.ngxSpinnerService.hide();
              this.alertService.openSnackBar(
                "Application Submitted Successfully",
                null,
                1000
              );

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            },
            error: () => {
              this.ngxSpinnerService.hide();
              this.alertService.openSnackBar("Failed to submit application");
            }
          });
      } catch (error) {
        this.ngxSpinnerService.hide();
      }
    });
  }

  onReject(): void {
    let dialogRef = this.dialog.open(RejectApplicationComponent, {
      autoFocus: false,
      data: {
        id: this.id
      }
    });

    dialogRef.afterClosed().subscribe((value) => {
      if (!value) return;

      this.alertService.openSnackBar(
        "Application Submitted Successfully",
        null,
        1000
      );

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  }
}

interface SectionList {
  section: string;
  sectionList?: SectionData[];
}

interface SectionData {
  sectionTitle: string;
  sectionIcon: string;
  fieldList: FieldData[];
}
